const carouselItems = [
  {
    title: '《我独自升级》完结纪念',
    desc: '现象级韩漫神作完结，全179话离线资源已整理完毕，一次下载永久收藏。',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20warrior%20in%20dark%20armor%20with%20glowing%20energy%2C%20epic%20fantasy%20art%2C%20dynamic%20composition%2C%20warm%20dark%20tones%2C%20high%20contrast%2C%20cinematic%20lighting&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '必看神作',
  },
  {
    title: '2026夏季新番速递',
    desc: '夏日韩漫新作大盘点，《反派小姐的男主人公》领衔，十部新番离线畅读。',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20summer%20themed%20Korean%20webtoon%20illustration%20with%20multiple%20characters%20in%20bright%20colorful%20outfits%2C%20cheerful%20summer%20vibes%2C%20beautiful%20art%20style%2C%20warm%20coral%20and%20golden%20tones%2C%20clean%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '新番推荐',
  },
  {
    title: '韩漫恋爱专题：心动篇',
    desc: '精选50部高分恋爱韩漫，从校园甜宠到办公室恋情，满足你的少女心。',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20beautiful%20romance%20art%2C%20warm%20pink%20and%20cream%20tones&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '恋爱特辑',
  },
  {
    title: '韩漫APK横评：谁最好用',
    desc: '五大主流韩漫APP全面对比，从画质、离线体验、更新速度到资源量一文看懂。',
    cover: 'https://readdy.ai/api/search-image?query=A%20comparison%20layout%20of%20multiple%20smartphones%20showing%20different%20Korean%20webtoon%20app%20interfaces%2C%20clean%20tech%20review%20style%2C%20warm%20coral%20background%2C%20minimalist%20product%20photography&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '深度横评',
  },
  {
    title: '悬疑韩漫烧脑合集',
    desc: '不可错过的悬疑推理韩漫推荐，反转不断、烧脑刺激，离线下载慢慢品味。',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20suspenseful%20Korean%20manhwa%20style%20illustration%20with%20dark%20alley%20and%20silhouette%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20warm%20dark%20amber%20tones%2C%20cinematic%20composition&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '悬疑精选',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            精选韩漫热点专题，一站掌握韩漫动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`韩漫之家 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading text-base font-semibold text-white mb-1">
                    {item.title}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}